// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__20fUG","itemTitle":"ClientEmergencyInfo_itemTitle__9n3iH","itemText":"ClientEmergencyInfo_itemText__3F9HN"};